import axiosConfig from "./axiosConfig";
import { MultiCurveCandidate } from "./postHhDataTempDetectMultiCurve";

// process_auto either kicks off a normal single-curve LRO ({operationKey,
// status: "processing"}) OR, when it detects a multi-curve file at medium+
// confidence, short-circuits with {status: "multi_curve_detected", candidates}
// and no operationKey - the FE then routes the file into the split-review flow.
interface HhDataTempProcessAutoResponse {
  operationKey?: string;
  status: string;
  candidates?: MultiCurveCandidate[];
  reason?: string;
}

const postHhDataTempProcessAuto = async (
  authToken: string,
  fileGuid: string
): Promise<HhDataTempProcessAutoResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/${fileGuid}/process_auto`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postHhDataTempProcessAuto;
